import { createFileRoute } from "@tanstack/react-router";
import { protectedRoute } from "@/lib/protectedRoute";
import { TemplateCreate } from "@/pages/TemplateCreate";

// Free plans can create templates (AI template creation is included in the
// free plan's recording allowance), so this route only requires sign-in.
export const Route = createFileRoute("/template/new")({
  component: TemplateCreate,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
